<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <el-form inline class="search-header" :model="searchData">
      <el-form-item label="关键字" class="kw">
        <el-input
          placeholder="请输入"
          v-model="searchData.keywordValue"
          class="input-with-select"
          size="small"
        >
          <el-select
            v-model="searchData.keywordName"
            slot="prepend"
            placeholder="请选择"
            size="small"
            style="width: 150px"
          >
            <el-option
              v-for="item in searchTypeOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item label="下次跟进日期">
        <el-date-picker
          style="width: 300px"
          size="small"
          v-model="searchData.nextFollowUpDateRange"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="流转时间">
        <el-date-picker
          style="width: 300px"
          size="small"
          v-model="searchData.transferTimeRange"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="售后状态">
        <el-select
          style="width: 180px"
          v-model="searchData.afterSaleStatusList"
          placeholder="请选择"
          size="small"
          multiple
          clearable
        >
          <el-option
            v-for="item in afterSaleStatusOptions"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否特批">
        <el-select v-model="searchData.isForceApprove" placeholder="请选择" size="small" clearable>
          <el-option label="否" :value="false"></el-option>
          <el-option label="是" :value="true"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="机构资方">
        <SelectCapitalOrg v-model="searchData.capitalOrgCodeList" multiple />
      </el-form-item>
      <el-form-item label="">
        <el-button
          @click="getList"
          type="primary"
          icon="el-icon-search"
          size="small"
          >搜索</el-button
        >
        <el-button
          @click="reset"
          size="small"
          type="info"
          icon="el-icon-refresh"
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <el-divider></el-divider>

    <div class="export-btn">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-download"
        @click="downloadExcel"
        >导出</el-button
      >
    </div>

    <tp-table
      :isCheckBox="false"
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :pageSize.sync="pageSize"
    />

    <!-- 跟进记录组件 -->
    <FollowUpRecord
      :visible.sync="followUpRecordVisible"
      :order-info="currentOrder"
      :show-add-form="false"
      @success="handleFollowUpSuccess"
    />

    <!-- 订单流转记录组件 -->
    <OrderTransfer
      :visible.sync="orderTransferRecordVisible"
      :order-no="currentOrderNo"
      :menu-type="6"
      @success="handleTransferRecordSuccess"
    />
  </div>
</template>

<script>
import { getOrderDetailRouteName } from "@/utils/order-detail-route";
import { authBtnMixin } from "@/mixins/authBtnMixin";
import {
  getAfterSaleOrderListAPI,
  exportAfterSaleOrderAPI,
} from "../api/after-sale-order";
import {
  EnumAfterSaleMenuType,
  AfterSaleMenuTypeToFileNameMap,
  AfterSaleStatusList,
} from "@/enum/dict/afterSaleOrder";
import { dateFormat } from "@/utils/index.js";
import FollowUpRecord from "../components/follow-up-record.vue";
import OrderTransfer from "../components/order-transfer.vue";
import { getAfterSaleOrderColumns } from "../utils/columns";
import SelectCapitalOrg from "@/views/components/select-capital-org.vue";

// 操作列定义
const operationColumn = {
  label: "操作",
  minWidth: "200",
  fixed: "right",
  customRender(h, row) {
    return (
      <div>
        <el-link
          underline={false}
          type="primary"
          style="margin-right: 10px"
          onClick={() => this.handleOrderDetail(row)}
        >
          订单详情
        </el-link>
        <el-link
          underline={false}
          type="primary"
          style="margin-right: 10px"
          onClick={() => this.handleOrderBill(row)}
        >
          账单
        </el-link>
        <el-link
          underline={false}
          type="primary"
          style="margin-right: 10px"
          onClick={() => this.handleContractDetail(row)}
        >
          合同凭证
        </el-link>
        <el-link
          underline={false}
          type="primary"
          style="margin-right: 10px"
          onClick={() => this.handleFollowUpRecord(row)}
        >
          跟进记录
        </el-link>
        <el-link
          underline={false}
          type="primary"
          onClick={() => this.handleOrderTransferRecord(row)}
        >
          订单流转记录
        </el-link>
      </div>
    );
  },
};

// 使用共用的表格列定义
const columns = getAfterSaleOrderColumns(operationColumn);

export default {
  name: "AfterSalesDetails",
  mixins: [authBtnMixin],
  components: {
    FollowUpRecord,
    OrderTransfer,
    SelectCapitalOrg,
  },
  data() {
    return {
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        keywordName: "memberName",
        keywordValue: "",
        nextFollowUpDateRange: [],
        transferTimeRange: [],
        afterSaleStatusList: [],
        isForceApprove: null,
        capitalOrgCodeList: [],
      },
      searchTypeOptions: [
        { name: "订单号", value: "orderNo" },
        { name: "客户姓名", value: "memberName" },
        { name: "手机号", value: "memberMobile" },
      ],
      afterSaleStatusOptions: AfterSaleStatusList,
      followUpRecordVisible: false,
      orderTransferRecordVisible: false,
      currentOrder: null,
      currentOrderNo: "",
    };
  },
  mounted() {
    this.getList();
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
  },
  methods: {
    buildParams(isExport = false, defaultParams = {}) {
      const params = {
        ...defaultParams,
        menuType: EnumAfterSaleMenuType.AFTER_SALES_DETAILS,
        afterSaleStatusList: isExport ? this.searchData.afterSaleStatusList : this.searchData.afterSaleStatusList.join(","),
        isForceApprove: this.searchData.isForceApprove,
        capitalOrgCodeList: isExport ? this.searchData.capitalOrgCodeList : this.searchData.capitalOrgCodeList.join(","),
      };

      // 处理关键字搜索
      if (this.searchData.keywordName && this.searchData.keywordValue) {
        params[this.searchData.keywordName] = this.searchData.keywordValue;
      }

      // 处理下次跟进日期范围
      if (this.searchData.nextFollowUpDateRange) {
        params.leftNextFollowDate = this.searchData.nextFollowUpDateRange[0];
        params.rightNextFollowDate = this.searchData.nextFollowUpDateRange[1];
      }

      // 处理流转日期范围
      if (this.searchData.transferTimeRange) {
        params.leftFlowDate = this.searchData.transferTimeRange[0];
        params.rightFlowDate = this.searchData.transferTimeRange[1];
      }

      return params;
    },
    async getList() {
      const params = this.buildParams(false, {
        page: this.currentPage,
        pageSize: this.pageSize,
      });

      const res = await getAfterSaleOrderListAPI(params);

      this.list = res.list || [];
      this.total = res.total || 0;
    },
    reset() {
      this.searchData = {
        keywordName: "memberName",
        keywordValue: "",
        nextFollowUpDateRange: [],
        transferTimeRange: [],
        afterSaleStatusList: [],
        isForceApprove: null,
        capitalOrgCodeList: [],
      };
      this.currentPage = 1;
      this.getList();
    },
    handleOrderDetail(row) {
      const link = this.$router.resolve({
        name: getOrderDetailRouteName(row.order?.createTime),
        params: { id: row.order?.orderNo },
        query: {
          memberId: row.member?.id,
          orderType: row.order?.orderType,
        },
      });
      window.open(link.href, "_blank");
    },
    handleOrderBill(row) {
      const link = this.$router.resolve({
        name: "OrderBill",
        params: { id: row.order?.orderNo },
      });
      window.open(link.href, "_blank");
    },
    handleContractDetail(row) {
      const link = this.$router.resolve({
        name: "OrderContractDetail",
        params: { id: row.order?.orderNo },
      });
      window.open(link.href, "_blank");
    },
    handleFollowUpRecord(row) {
      this.currentOrder = row;
      this.followUpRecordVisible = true;
    },
    handleOrderTransferRecord(row) {
      this.currentOrderNo = row.order?.orderNo || "";
      this.orderTransferRecordVisible = true;
    },
    handleFollowUpSuccess() {
      this.getList();
    },
    handleTransferRecordSuccess() {
      this.getList();
    },
    async downloadExcel() {
      const params = this.buildParams(true);

      const fileName = `OK租机${AfterSaleMenuTypeToFileNameMap.get(EnumAfterSaleMenuType.AFTER_SALES_DETAILS)}${dateFormat()}.xlsx`;

      exportAfterSaleOrderAPI(params, fileName);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  .el-divider--horizontal {
    margin: 0 0 20px;
  }
}

.search-header {
  .kw {
    ::v-deep {
      .input-with-select {
        vertical-align: middle;
      }
      .input-with-select .el-input-group__prepend {
        background-color: #fff;
      }
    }
  }
}

.export-btn {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}
</style>
